function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2500 2495",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5,178.758C2.5,80.06 85.065,0 186.869,0L2313.13,0C2414.93,0 2497.5,80.06 2497.5,178.758L2497.5,2316.34C2497.5,2415.04 2414.93,2495 2313.13,2495L186.869,2495C85.065,2495 2.5,2415.04 2.5,2316.34L2.5,178.758Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.719,2087.98L760.719,964.733L387.371,964.733L387.371,2087.98L760.719,2087.98ZM574.146,811.426C704.306,811.426 785.369,725.153 785.369,617.337C782.964,507.116 704.306,423.248 576.651,423.248C448.895,423.248 365.427,507.116 365.427,617.337C365.427,725.153 446.39,811.426 571.741,811.426L574.146,811.426ZM967.334,2087.98L1340.68,2087.98L1340.68,1460.73C1340.68,1427.16 1343.09,1393.59 1353.01,1369.64C1379.96,1302.51 1441.38,1233.07 1544.59,1233.07C1679.66,1233.07 1733.67,1336.08 1733.67,1487.08L1733.67,2087.88L2107.02,2087.88L2107.02,1443.89C2107.02,1098.9 1922.85,938.381 1677.26,938.381C1475.85,938.381 1387.48,1050.91 1338.28,1127.56L1340.78,1127.56L1340.78,964.733L967.334,964.733C972.243,1070.14 967.334,2087.98 967.334,2087.98Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e20a91cb19f9affc97f07584e6e10de1.svg";
export { ForwardRef as ReactComponent };